import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Art } from './Art';
/**
 * An original boxy cab-over kei microvan, side on, facing right: cream body, vermilion
 * stripe, indigo glass, roof rack. Parts the road carousel animates are classed: the body
 * (`mk-van__body`, pitches on its wheels), each wheel's hub (`mk-van__hub`, spins) and the
 * tailpipe tip (`mk-van__pipe`, where the exhaust puff starts). 128 × 80.
 */ export function KeiVan({ title, className }) {
    return /*#__PURE__*/ _jsx(Art, {
        viewBox: "0 0 128 80",
        title: title,
        className: className,
        children: /*#__PURE__*/ _jsx(VanShape, {})
    });
}
/** The van's drawing in its own 128 × 80 space, for scenes that park it somewhere. */ export function VanShape() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("ellipse", {
                className: "fsh",
                cx: "64",
                cy: "71.5",
                rx: "55",
                ry: "2.6"
            }),
            /*#__PURE__*/ _jsxs("g", {
                className: "mk-van__body",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        className: "sa",
                        d: "M18 10.6h84M22 13.6v-3M50 13.6v-3M78 13.6v-3M98 13.4v-2.8"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "fc",
                        d: "M12 60.4c-.9-14-1-29.4 0-41.4.2-3.4 2.6-5 6-5l83-.6c3 0 4.6 1 6 3.6l7 14c1.5 3 2 5 2 8l.5 18c0 2.6-1.5 3.6-4 3.6H108a10 10 0 0 0-20 0H40a10 10 0 0 0-20 0h-5c-2 0-3-.2-3-.4Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "fb n",
                        d: "M13.1 44.2 115.1 44l.3 4.6-102.2.2Z"
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        className: "fa",
                        x: "17",
                        y: "19",
                        width: "21.5",
                        height: "14",
                        rx: "2"
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        className: "fa",
                        x: "43",
                        y: "19",
                        width: "25.5",
                        height: "14",
                        rx: "2"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "fa",
                        d: "M73 19h27c1.5 0 2.3.6 3 2l5 10.5c.5 1.3 0 2-1.5 2H73Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "sc thin",
                        d: "m21 30 7-8M47 30.5l8-9M78 31l9-10",
                        opacity: ".55"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M41 17v41.4M71 16.4v42M41 37h30M62 39h5M75 39h5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M106.6 26.5 112 25"
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        className: "fp thin",
                        x: "111",
                        y: "22.4",
                        width: "3.4",
                        height: "5",
                        rx: "1"
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        className: "fo thin",
                        x: "110.6",
                        y: "37.6",
                        width: "5.2",
                        height: "4.4",
                        rx: "1.2"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "fl",
                        d: "M106.4 56.6h11.2v4.4h-12.4ZM10.4 56.8h5.4v4.2h-5.6Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "mk-van__pipe sa",
                        d: "M14 61.6 7.6 63",
                        strokeWidth: "2.6"
                    })
                ]
            }),
            [
                30,
                98
            ].map((cx)=>/*#__PURE__*/ _jsxs("g", {
                    children: [
                        /*#__PURE__*/ _jsx("circle", {
                            className: "fty",
                            cx: cx,
                            cy: "61",
                            r: "8.6"
                        }),
                        /*#__PURE__*/ _jsxs("g", {
                            className: "mk-van__hub",
                            style: {
                                transformOrigin: `${cx}px 61px`
                            },
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    className: "fc thin",
                                    cx: cx,
                                    cy: "61",
                                    r: "3.8"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    className: "thin",
                                    d: `M${cx} 57.6v6.8M${cx - 3} 59.3l6 3.4M${cx - 3} 62.7l6-3.4`
                                })
                            ]
                        })
                    ]
                }, cx))
        ]
    });
}
